export default "__VITE_ASSET__c5c2ba04__"